export default __webpack_public_path__ + "static/media/ShawnaLovelace.a683e17e.png";